import { getLogger } from 'app-components/utils/core';
import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import { commonSelectors, createQcsThunks, createResourceEntityAdapter } from '../core/resourceSliceUtils';
import { mileageTrackerPurposeApi } from '../mileage-tracker/mileageTrackerApi';
import {
  MILEAGE_TRACKER_PURPOSE_REDUCER_KEY,
  type MileageTrackerPurposeState,
  type MileageTrackerPurposeType,
} from './mileageTrackerPurposeTypes';

const initialState: MileageTrackerPurposeState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};
const log = getLogger('app-components/flux/mileageTrackerPurpose/mileageTrackerPurposeSlice.ts');

const entityAdapter = createResourceEntityAdapter<MileageTrackerPurposeType>();
const entitySelectors = entityAdapter.getSelectors();

export const slice = createAppSlice({
  name: MILEAGE_TRACKER_PURPOSE_REDUCER_KEY,
  initialState: entityAdapter.getInitialState(initialState),
  reducers: (create) =>
    createQcsThunks({
      create,
      refetch(dispatch) {
        dispatch(mileageTrackerPurposeActions.fetch());
      },
      api: mileageTrackerPurposeApi,
      adapter: entityAdapter,
      log,
    }),
  selectors: {
    ...entitySelectors,
    ...commonSelectors,
  },
});

export const mileageTrackerPurposeActions = slice.actions;
export const mileageTrackerPurposeSelectors = slice.selectors;
export { slice as mileageTrackerPurposeSlice };

export default slice.reducer;
